import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    [
      _c(VBreadcrumbs, { attrs: { items: _vm.breadCombs } }),
      _c(
        VRow,
        { attrs: { justify: "end" } },
        [
          _c(
            VDialog,
            {
              attrs: { persistent: "", "max-width": "290" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on }) {
                    return [
                      _c(
                        VBtn,
                        _vm._g(
                          {
                            staticClass: "primary mr-4",
                            attrs: { small: "", dark: "" },
                          },
                          on
                        ),
                        [
                          _vm._v(
                            _vm._s(_vm.$vuetify.lang.t("$vuetify.label.add"))
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.dialog,
                callback: function ($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog",
              },
            },
            [
              _c(
                VCard,
                [
                  _c(VCardTitle, { staticClass: "headline" }, [
                    _vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.label.add"))),
                  ]),
                  _c(
                    VCardActions,
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.label.inventoryId"
                          ),
                          "error-messages": _vm.errorMessage,
                        },
                        model: {
                          value: _vm.inventoryId,
                          callback: function ($$v) {
                            _vm.inventoryId = $$v
                          },
                          expression: "inventoryId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$vuetify.lang.t("$vuetify.base.cancel"))
                      ),
                    ]
                  ),
                  _c(
                    VBtn,
                    {
                      staticClass: "mr-4",
                      attrs: { color: "green darken-1", text: "" },
                      on: { click: _vm.addLabel },
                    },
                    [_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.base.add")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(VDivider),
      _c(VSpacer),
      _c(VTextField, {
        attrs: {
          label: _vm.$vuetify.lang.t("$vuetify.label.searchText"),
          "error-messages": _vm.searchErrorMessage,
        },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.searchChanged.apply(null, arguments)
          },
          "click:append": _vm.searchChanged,
        },
        model: {
          value: _vm.search,
          callback: function ($$v) {
            _vm.search = $$v
          },
          expression: "search",
        },
      }),
      _c(VDataTable, {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.lables,
          options: _vm.options,
          "server-items-length": _vm.total,
          loading: _vm.loading,
          "disable-sort": "true",
        },
        on: {
          "update:options": [
            function ($event) {
              _vm.options = $event
            },
            _vm.optionsChanged,
          ],
        },
        scopedSlots: _vm._u([
          {
            key: "item.option",
            fn: function ({ item }) {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { text: "", small: "", color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.routerTo(item)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.base.detail")))]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }